/**
 * Limits that the app, the serverless functions and the copy all quote. One
 * home, so a sentence on a page can never disagree with the code that enforces
 * it. The API imports this file too (ESM, so with the `.js` suffix).
 */
export const AI_PROMPT_CHARS = 1000
export const AI_REQUESTS_PER_DAY = 20
export const AI_SUMMARY_RESPONSES = 500
export const WEBHOOKS_PER_SURVEY = 5
/** Extra attempts after the first when a webhook cannot be reached or answers 5xx. */
export const WEBHOOK_RETRIES = 2
export const LINK_FIELDS_PER_SURVEY = 20
export const LINK_FIELD_VALUE_CHARS = 500
